import { PaymentLinkMenuItem, ViewDetailMenuItem } from "./components";

export function MenuItem() {
  return <></>;
}

MenuItem.PaymentLink = PaymentLinkMenuItem;
MenuItem.ViewDetail = ViewDetailMenuItem;
